/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StarShootingIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABYElEQVR4nO2Vv0oDQRDGD/+ChZURS1/ASvuzXGR3ZoIsM4l2woGdjXU6QbARwZfwCWJjpzYKAVOIIAgBH0EQjTJR4wl3ubtcBAs/2OJmdn/f7AzLBcFflyPeBuIb7/34bxlcA8kbIq+OHI7Ii0DSVQNAORq5ARDv9uAfBo+NRmOsJFDu+8CM5ZBfLdbWCxk4lB2H/JzLBPl8zfuF4rcAWQGSuwHwrkM+jKJoMhNmbW3OEV86krN43JiNWSB5SGnNVq5KFQ7Erc8BXsRz1ermvEN5SWnNXjE4cUu/43lHHMWAT46k/X0DuS0FVwFKswcjaSPWl7z3U0B88PUmNBYMC1c54hNAObbWzgQxuaoYPUdUXw7ywq3GexXzflBGgHyaCKf+oJs/iilqqpv1UCKcsk0LyXhfSYKblPg/vFK6LWkD1d8goFyVgg+CGGOmgaSj+aHgeSCaD8NwYij4SCEpegdGhU8lXwhqJQAAAABJRU5ErkJggg==)
 */
export const StarShootingIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.93 1.51a.74.74 0 0 0-1.41 0l-1.13 3.47h-3.65a.74.74 0 0 0-.43 1.35l2.95 2.14-1.13 3.47a.74.74 0 0 0 1.14.83l2.95-2.15 2.96 2.15a.74.74 0 0 0 1.14-.83l-1.13-3.47 2.95-2.14a.74.74 0 0 0-.43-1.35h-3.65l-1.13-3.47ZM10.7 14.7a1 1 0 0 0-1.4-1.4l-8 8a1 1 0 1 0 1.4 1.4l8-8ZM9.7 8.3a1 1 0 0 1 0 1.4l-6 6a1 1 0 0 1-1.4-1.4l6-6a1 1 0 0 1 1.4 0ZM15.7 15.7a1 1 0 0 0-1.4-1.4l-6 6a1 1 0 1 0 1.4 1.4l6-6Z"
        className={colorClass}
      />
    </svg>
  );
};
